import classNames from 'classnames';
import PropTypes from 'prop-types';

import styles from './Fieldset.module.scss';

export default function Fieldset({ children, legend, disabled, hideLegend }) {
  return (
    <fieldset
      disabled={disabled}
      className={classNames(styles.fieldset, 'u-grid')}
    >
      <legend
        className={classNames(
          styles.legend,
          'u-typography-heading-3',
          'u-mb-2',
          'u-mb-3@from-md',
          hideLegend && 'u-visually-hidden'
        )}
      >
        {legend}
      </legend>
      {children}
    </fieldset>
  );
}

Fieldset.propTypes = {
  children: PropTypes.node.isRequired,
  legend: PropTypes.string.isRequired,
  disabled: PropTypes.bool,
  hideLegend: PropTypes.bool,
};
